import '@/src/styles/base/_base.scss';
import '@/src/styles/base/_common.scss';
import '@/src/styles/pages/_etc.scss';
import { DEEP_LINK, DEEP_LINK_MARKET } from '../enum/Constants';
import { firebaseInit } from './firebase';
import { closeDialog, isApp, isIOS, openDialog } from './utils';
const goAppLink = () => {
    if (isApp()) {
        window.parent.location.href = `${DEEP_LINK}/my`;
    }
    else if (isIOS()) {
        openDialog('iOS 앱은 준비중입니다.', closeDialog);
    }
    else {
        window.open(`${DEEP_LINK_MARKET}`, '_self');
    }
};
const initialize = () => {
    firebaseInit();
    const download = document.getElementById('download');
    if (download) {
        download.addEventListener('click', goAppLink);
    }
};
initialize();
